import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-widget-taxe-fonciere',
    templateUrl: './taxe-fonciere.component.html',
    styleUrls: ['./taxe-fonciere.component.scss']
})

export class TaxeFonciereComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();

    echartsIntance = null;

    options = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                animation: false
            },
            formatter: params => {
                let lib = params[0].name + '<br/>';
                params.forEach(d => {
                    lib += '<span style="font-size:24px;">• </span>' + d.seriesName + ' : '
                        + d.data.toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' %';
                });
                return lib;
            }
        },
        legend: {
            orient: 'vertical',
            right: '40px',
            bottom: '70px',
            align: 'right',
        },
        grid: {
            left: '20px',
            right: '1%',
            top: '40px',
            bottom: '15',
            containLabel: true
        },
        xAxis: {
            data: [],
            axisTick: {
                alignWithLabel: true,
            },
        },

        yAxis: {
            type: 'value',
            label: {
                formatter: '{b} <br/>{a} : {c} %',
            },
            min: 100,
            axisLabel: {
                formatter: '{value} %'
            },
        },
        color: ['#2980B9'],

    };

    data = {
        series: [],
    };

    constructor() {
    }

    ngOnInit() {
        this.setData();
        this.extChange.subscribe(data => {
            this.setData();
        });
    }

    setData() {
        this.options.yAxis.min = 100;
        this.options.xAxis.data = [];

        const taux = [];
        const taxe = this.favorite.ad_city.taxe_fonciere_annuelle;

        if (taxe) {
            // Seules les années réellement présentes sont tracées : un trou dans l'historique
            // ne doit jamais être comblé par 0, ce qui ferait chuter la courbe à tort.
            Object.keys(taxe).sort().forEach(keys => {
                if (taxe[keys] === null || taxe[keys] === undefined) {
                    return;
                }
                const value = taxe[keys] * 100;
                taux.push(value);
                this.options.xAxis.data.push(keys.replace('Y', ''));
                if (this.options.yAxis.min > (value * 0.8)) {
                    this.options.yAxis.min = Math.floor(value * 0.8);
                }
            });
        }

        if (this.options.yAxis.min < 0 || taux.length === 0) {
            this.options.yAxis.min = 0;
        }

        this.data = {
            series: [
                {
                    name: 'Taux de taxe foncière',
                    type: 'line',
                    data: taux,
                },
            ]
        };

        if (this.echartsIntance) {
            this.echartsIntance.setOption(this.options);
        }
    }

    hasData() {
        return this.data.series.length > 0 && this.data.series[0].data.length > 0;
    }

    onChartInit(ec) {
        this.echartsIntance = ec;
    }
}
